import {
  GET_ALL_PAYMENTS_REQUEST,
  GET_ALL_PAYMENTS_SUCCESS,
  GET_ALL_PAYMENTS_FAIL,
  GET_PAYMENT_BY_ID_REQUEST,
  GET_PAYMENT_BY_ID_SUCCESS,
  GET_PAYMENT_BY_ID_FAIL,
  GET_PAYMENT_DETAILS_BY_ID_REQUEST,
  GET_PAYMENT_DETAILS_BY_ID_SUCCESS,
  GET_PAYMENT_DETAILS_BY_ID_FAIL,
  ADD_PAYMENT_REQUEST,
  ADD_PAYMENT_SUCCESS,
  ADD_PAYMENT_FAIL,
  UPDATE_PAYMENT_REQUEST,
  UPDATE_PAYMENT_SUCCESS,
  UPDATE_PAYMENT_FAIL,
} from "../constants/PaymentConstants"

const initialState = {
  responseBody: null,
  loading: false,
  msg: null,
}

// ========== REDUCERS ==========
export const GetAllPayments = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_PAYMENTS_REQUEST:
      return { ...state, loading: true, msg: null }
    case GET_ALL_PAYMENTS_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null }
    case GET_ALL_PAYMENTS_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null }
    default:
      return state
  }
}

export const GetPaymentById = (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYMENT_BY_ID_REQUEST:
      return { ...state, loading: true, msg: null }
    case GET_PAYMENT_BY_ID_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null }
    case GET_PAYMENT_BY_ID_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null }
    default:
      return state
  }
}

export const GetPaymentDetailsById = (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYMENT_DETAILS_BY_ID_REQUEST:
      return { ...state, loading: true, msg: null }
    case GET_PAYMENT_DETAILS_BY_ID_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null }
    case GET_PAYMENT_DETAILS_BY_ID_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null }
    default:
      return state
  }
}

export const AddPayment = (state = initialState, action) => {
  switch (action.type) {
    case ADD_PAYMENT_REQUEST:
      return { ...state, loading: true, msg: null }
    case ADD_PAYMENT_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null }
    case ADD_PAYMENT_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null }
    default:
      return state
  }
}

export const UpdatePayment = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PAYMENT_REQUEST:
      return { ...state, loading: true, msg: null }
    case UPDATE_PAYMENT_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null }
    case UPDATE_PAYMENT_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null }
    default:
      return state
  }
}

// ========== SELECTORS ==========
export const selectAllPaymentsData = (state) => state.allpayments?.responseBody;
export const selectAllPaymentsLoading = (state) => state.allpayments?.loading;
export const selectAllPaymentsError = (state) => state.allpayments?.msg;

export const selectPaymentByIdData = (state) => state.paymentbyid?.responseBody;
export const selectPaymentByIdLoading = (state) => state.paymentbyid?.loading;
export const selectPaymentByIdError = (state) => state.paymentbyid?.msg;

export const selectPaymentDetailsByIdData = (state) => state.paymentdetailsbyid?.responseBody;
export const selectPaymentDetailsByIdLoading = (state) => state.paymentdetailsbyid?.loading;
export const selectPaymentDetailsByIdError = (state) => state.paymentdetailsbyid?.msg;

export const selectAddPaymentData = (state) => state.addpayment?.responseBody;
export const selectAddPaymentLoading = (state) => state.addpayment?.loading;
export const selectAddPaymentError = (state) => state.addpayment?.msg;

export const selectUpdatePaymentData = (state) => state.updatepayment?.responseBody;
export const selectUpdatePaymentLoading = (state) => state.updatepayment?.loading;
export const selectUpdatePaymentError = (state) => state.updatepayment?.msg;